import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createMultiValueStyle = ({
  colors,
  select,
}: ThemeType) => (): CSSObject => ({
  display: 'flex',
  minWidth: 0,
  boxSizing: 'border-box',
  minHeight: 24,
  marginRight: 5,
  marginTop: 2,
  marginBottom: 2,
  backgroundColor: colors[select.MULTI_VALUE_BACKGROUND_COLOR],
  borderRadius: select.MULTI_VALUE_BORDER_RADIUS,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: colors[select.MULTI_VALUE_BORDER_COLOR],
  paddingLeft: 7,
  paddingRight: 7,

});
